import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-complexe',
  templateUrl: './complexe.component.html',
  styleUrls: ['./complexe.component.css']
})
export class ComplexeComponent implements OnInit {

  constructor() {}
  ngOnInit(): void {}

}
